<script lang="ts">
    import {createEventDispatcher} from "svelte";
    import {onMount} from "svelte/internal";
    import { HipaaForm } from "../models/HipaaForm";
    import { HipaaSignatureInfo } from "../models/HipaaSignatureInfo";
    import {InsuredDetails} from "../models/InsuredDetails";

    import { StoredApplicationData } from "../services/Store";
    import { convertToDateString } from "../services/Utilities";
    import {HipaaAuthorizationService} from "../services/HipaaAuthorizationService";
    import {hipaaCompleted} from "../services/NavigationService";
    export let insured: InsuredDetails;
    export let disabled: boolean = true; 
    let signatureInfo = new HipaaSignatureInfo();
    let requiredCheckBoxCount = 0;  
    let complete: boolean = false;
    let hipaaService = new HipaaAuthorizationService();
    let promise = Promise.resolve(HipaaForm);
    let previousSignature: string; 
    let today = new Date();
    let date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
    const dispatch = createEventDispatcher();
    let isHipaaSigned = false;
    let disableContinueButton = true;
    const satisfiedCheckBoxCount = (checked: boolean) => {
        if (checked ) {
           requiredCheckBoxCount++;
        } else {
            requiredCheckBoxCount--;
            if (requiredCheckBoxCount < 0) {
                requiredCheckBoxCount = 0;
            }
        }
    }

    const hipaaAuthorizationClicked = (e) => {
        switch(e.target.id){
            case 'consumerReportCheckbox':
                signatureInfo.IsConsumerReportChecked = e.target.checked;
                break;
            case 'hipaaFormsAccessCheckbox':
                signatureInfo.IsHipaaFormsAccessChecked = e.target.checked;
                satisfiedCheckBoxCount(e.target.checked);
                break;
            case 'informationMisrepresentationCheckbox':
                signatureInfo.IsInformationMisrepresentationChecked = e.target.checked;
                satisfiedCheckBoxCount(e.target.checked);
                break;
            case 'termsOfUseCheckbox':
                signatureInfo.IsTermsOfUseCheckboxChecked = e.target.checked;
                satisfiedCheckBoxCount(e.target.checked);
                break;
            case 'insuredSignature':
                if (!previousSignature && e.target.value.length > 0) {
                    satisfiedCheckBoxCount(e.target.value.length > 0);
                    previousSignature = e.target.value;
                } else if (previousSignature && e.target.value.length == 0) {
                    satisfiedCheckBoxCount(e.target.value.length > 0);
                    previousSignature = '';
                }
                break;
        }
       }
       
    onMount(() => {          
       let appData =$StoredApplicationData;
       if (appData && appData.insuredDetails && appData.planDetails) {
        signatureInfo.insuredName = appData.insuredDetails.firstName + ' ' +  appData.insuredDetails.lastName;
        signatureInfo.insuredSSN = appData.insuredDetails.ssn;
        signatureInfo.policyNumber = appData.planDetails.policyNumber;
        signatureInfo.insuredDOB = convertToDateString(appData.insuredDetails.dateOfBirth);    
        signatureInfo.applicationState = appData.planDetails.issueState; 
        signatureInfo.insuredEmailAddress = appData.insuredDetails.emailAddress;
        signatureInfo.applicationId = appData.applicationId;
       }
       promise =  hipaaService.GetHipaaForm(signatureInfo.applicationState);
       
    });

    const hipaaSignatureComplete = (e) => {
        isHipaaSigned = true;
        complete = true;
        disableContinueButton = false;
        hipaaService.SignHipaaForm(signatureInfo);
        window.scrollTo(0,0);
        hipaaCompleted();
    }
</script>

    <div class="card-no-border" style="padding-left: 0px;">
        <h1>Electronically Sign My HIPAA Authorization</h1>
        <hr />
        <div>
            This document authorizes us to obtain information about you. We've made it easy by providing you the ability to sign online. No mail, no fax - just a simple type and click.
        </div>           
    </div>

    <div class="hipaa-electronick-signature card" style="height: 500px;overflow: scroll;">       
        {#await promise}
            <h1>Loading...</h1>
        {:then data}    
            {@html data.formContent}     
        {/await}       
    </div>

    <div class="card-no-border">          
        <h2 style="font-style: italic;">AUTHORIZATIONS AND INVESTIGATIVE CONSUMER REPORT</h2>
        <p style="font-size:large; font-weight: bold;">
            By signing below you are confirming your intent to continue with the application process.
        </p>           
    </div>

    <div class="grid-container twoBytwo text-section bold-text">     
        <div>           
            Date Of Authorization: <span class="bold-text">{date.toString()}</span>
        </div>
        <div>
            Name of Insured: <span class="bold-text">{signatureInfo.insuredName}</span>
        </div>
        <div>
            Date Of Birth: <span class="bold-text">{signatureInfo.insuredDOB}</span>
        </div>
        <div>
            Social Security Number: <span class="bold-text">{signatureInfo.insuredSSN}</span>
        </div>  
    </div>

    <hr />

    <div class="card-no-border"> 
        {#await promise}
        {:then data}         
                {#each data.hipaaDisclaimers as HipaaDisclaimer}
                    <div style="background-color: #F5F5F5">
                        <input on:change={hipaaAuthorizationClicked} type="checkbox" id={HipaaDisclaimer.disclaimerId} />
                        <span> {@html HipaaDisclaimer.htmlText}</span> 
                    </div><br>
                {/each}
        {/await}

    <br>

        <div class="control-row">
            <div class="control-group-horizontal">
                <label  for="insuredSignature">Sign  your name:</label>
                <input bind:value={signatureInfo.insuredSignature} on:keyup={hipaaAuthorizationClicked} id="insuredSignature" />
            </div>
        </div>


    {#await promise}
    {:then data}                
        <div>
          <label>  {requiredCheckBoxCount} of {data.hipaaDisclaimers.filter(x => x.isRequired == true).length + 1} required items completed</label>
        </div>

        <div>

            <button disabled={requiredCheckBoxCount < data.hipaaDisclaimers.filter(x => x.isRequired == true).length + 1} class="pl-cta-primary" on:click={hipaaSignatureComplete} style="margin-top:20px; text-transform: uppercase">CONTINUE TO NEXT STEP</button>
        </div>
    {/await}
    </div>

<style lang="scss">
    @use "../../component_scss_library/layout" as layout;
    @use "../../component_scss_library/buttons" as buttons;
    @use "../../component_scss_library/forms" as forms;

    .grid-container {
    display: grid;
    grid-gap: 10px;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 10px; 
    margin-bottom:30px;
    }  
    .twoBytwo {
    grid-template-columns: auto auto;
    grid-template-rows: auto auto;
    }
    .grid-container > div {
    background-color: #F5F5F5;
    text-align: left;
    padding: 10px 0;
    font-size: 20px;
    margin-left: 20px;
    }
</style>
